var render = function render(){
  var _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "채용관리",
      "topBtn": "",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "topBtn"
  }, [_c('recruitment-form', {
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("채용공고 등록")])];
      }
    }])
  })], 1), _c('template', {
    slot: "contents"
  }, [_c('recruitment-list-filter', {
    staticClass: "mb-4 mb-md-8",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }), (_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length ? [_c('div', {
    staticClass: "v-cards"
  }, _vm._l(_vm.items, function (item) {
    var _item$employment;
    return _c('v-card', {
      key: item._id,
      attrs: {
        "outlined": "",
        "rounded": "lg"
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('v-row', {
      staticClass: "row--x-large",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "recruitment-item__detail mb-10 mb-lg-0",
      attrs: {
        "cols": "12",
        "lg": ""
      }
    }, [_c('h5', {
      staticClass: "page-text--lg font-weight-medium mb-8 mb-lg-16"
    }, [_c('a', {
      attrs: {
        "href": `/recruitments/${item === null || item === void 0 ? void 0 : item._id}`,
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.subject) + " ")])]), item !== null && item !== void 0 && (_item$employment = item.employment) !== null && _item$employment !== void 0 && _item$employment.typesTexts ? _c('v-chip-group', {
      staticClass: "mb-4"
    }, _vm._l(item.employment.typesTexts, function (item) {
      return _c('v-chip', {
        key: item,
        attrs: {
          "small": "",
          "outlined": "",
          "color": "grey-d"
        }
      }, [_c('span', {
        staticClass: "grey-6--text"
      }, [_vm._v(_vm._s(item))])]);
    }), 1) : _vm._e(), _c('recruitment-list-item-application', _vm._b({}, 'recruitment-list-item-application', {
      item
    }, false))], 1), _c('v-col', {
      staticClass: "mb-10 mb-md-0",
      attrs: {
        "cols": "12",
        "md": "9",
        "lg": "auto"
      }
    }, [_c('v-row', {
      staticClass: "row--large"
    }, [_c('v-col', {
      staticClass: "mb-4 mb-md-0",
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "auto"
      }
    }, [_c('recruitment-list-item-state', _vm._g(_vm._b({}, 'recruitment-list-item-state', {
      item
    }, false), {
      put: _vm.put
    }))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "8",
        "lg": "auto"
      }
    }, [_c('recruitment-list-item-counts', _vm._b({}, 'recruitment-list-item-counts', {
      item
    }, false))], 1)], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "3",
        "lg": "auto"
      }
    }, [_c('v-btn', {
      staticClass: "mw-lg-100px mb-4 mb-lg-8",
      attrs: {
        "to": `${_vm.$route.path}/${item === null || item === void 0 ? void 0 : item._id}/recruits`,
        "outlined": "",
        "small": "",
        "block": "",
        "color": "primary"
      }
    }, [_vm._v("합격자관리")]), _c('v-btn', {
      staticClass: "mw-lg-100px mb-4 mb-lg-8",
      attrs: {
        "to": `${_vm.$route.path}/${item === null || item === void 0 ? void 0 : item._id}/applications`,
        "outlined": "",
        "small": "",
        "block": "",
        "color": "primary"
      }
    }, [_vm._v("모집현황(목록)")]), _c('v-btn', {
      staticClass: "mw-lg-100px mb-4 mb-lg-8",
      attrs: {
        "to": `${_vm.$route.path}/${item === null || item === void 0 ? void 0 : item._id}/kanban`,
        "outlined": "",
        "small": "",
        "block": "",
        "color": "primary"
      }
    }, [_vm._v("모집현황(칸반)")]), _c('recruitment-form', {
      attrs: {
        "value": item
      },
      on: {
        "input": _vm.updateItem
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var attrs = _ref2.attrs,
            on = _ref2.on;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "min-w-lg-100px",
            attrs: {
              "outlined": "",
              "small": "",
              "block": "",
              "color": "grey-d"
            }
          }, 'v-btn', attrs, false), on), [_c('span', {
            staticClass: "grey-6--text"
          }, [_vm._v("공고수정")])])];
        }
      }], null, true)
    })], 1)], 1)], 1)]);
  }), 1), _c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : _vm.$route.query.state ? [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v("채용공고가 없습니다.")])])] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 등록된 채용공고가 없습니다. ")]), _c('recruitment-form', {
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "v-btn--column",
          attrs: {
            "text": "",
            "height": "auto",
            "color": "transparent"
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "icon icon-plus-lg"
        }), _c('span', {
          staticClass: "mt-6 mt-lg-14 grey-9--text"
        }, [_vm._v("채용공고 등록하기")])])];
      }
    }])
  })], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }